import { motion } from "framer-motion";
import styles from "./style.module.scss";
const strategicLeadGenerationList = [
    {
        description:
            "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements.",
    },
    {
        description:
            "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions.",
    },
    {
        description:
            "Our state-of-the-art lead verification system is designed to filter out fraud, perform syntax checks, and flag duplicates. To ensure high-quality leads, our call center team nurtures verified leads. We use keyword optimization and strategic timing to increase conversions. You can trust that we will verify each lead before promptly sending it to you.",
    },
    {
        description:
            "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients.",
    },
    {
        description:
            "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs.",
    },
    {
        description:
            "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved.",
    },
];
const paragraphsStyle =
    "lg:mt-4 mt-2 font-light lg:text-lg 3xl:text-[26px] 3xl:leading-[2.5rem] text-base lg:leading-8 text-[#351C4F]";
export default function HowWeWork({
    mainData,
}: {
    mainData?: {
        title?: string;
        list?: { title?: string; description: string }[];
    };
}) {
    return (
        <section className="lg:my-32 my-16  ">
            <motion.h2
                transition={{ duration: 1.5 }}
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-[#351C4F] font-bold  3xl:text-7xl lg:text-5xl lg:leading-[4rem] text-2xl leading-9 text-center 3xl:max-w-[1415px] 3xl:leading-[5.5rem] lg:max-w-[915px] mx-auto"
            >
                {mainData?.title ? mainData?.title : "How We Work"}
            </motion.h2>

            <ul className="lg:mt-16 mt-8 flex flex-wrap justify-center 3xl:gap-20 gap-6">
                {(mainData?.list
                    ? mainData.list
                    : (strategicLeadGenerationList as {
                          title?: string;
                          description: string;
                      }[])
                ).map((el, index) => (
                    <motion.li
                        transition={{ duration: 1.5 }}
                        initial={{ opacity: 0, y: 150 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        key={index}
                        className={styles["stepStyle"]}
                    >
                        <h3>{index + 1}</h3>

                        {el.title && (
                            <div className="lg:mt-8 mt-6 font-bold 3xl:text-5xl lg:text-3xl 3xl:leading-[4rem] text-xl lg:leading-10 text-[#351C4F]">
                                {el.title}
                            </div>
                        )}

                        <p
                            className={`${paragraphsStyle} ${
                                el.title ? "" : "lg:mt-8 mt-6"
                            }`}
                        >
                            {el.description}
                        </p>
                    </motion.li>
                ))}
            </ul>
        </section>
    );
}
